<template>
  <div class="mod-search__display mod-search__display--division" :class="{ 'mod-search__display--branch': isGameShop }">
    <div class="mod-search-box">
      <div class="mod-search-bar service-new-list" role="search">
        <form class="mod-search-bar__form" action="" @submit.prevent="searchSubmit(null, 'submit')">
          <span class="mod-icon-search"></span>
          <div class="mod-search-bar__box">
            <input
              v-if="showInput"
              id="searchInput"
              v-model="searchInput"
              v-focus="inputFocus"
              type="search"
              class="mod-search-bar__input"
              placeholder="搜索英雄、皮肤名称试试"
              required=""
              @focus="onFocus"
              @blur="onBlur"
            />
            <a
              v-show="searchInput"
              for="searchInput"
              class="mod-icon-clear"
              role="button"
              aria-label="删除输入"
              @click="clearSearchInput"
            ></a>
          </div>
        </form>
        <a class="mod-icon-clear--text" role="button" aria-label="取消搜索" @click.stop="closeSearchBox">取消</a>
      </div>
    </div>
    <!-- 历史搜索 -->
    <div v-if="!showSearchLoading && searchHistory.length && !searchInput" class="mod-search__result mod-search__synthesize">
      <i class="i_delete" tabindex="0" role="button" aria-label="删除历史搜索记录" @click.stop="clearSearchHistory">
        <span class="mod-icon-delete"></span>
      </i>
      <h3 class="mod-search__tit">历史搜索</h3>
      <ul class="mod-hot__list">
        <li
          v-for="(item, index) in searchHistory"
          :key="'searchHistory' + index"
          class="mod-hot__item"
          role="button"
          @click.stop="searchSubmit(item, 'history')"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <br v-if="!showSearchLoading && searchTag.length && !searchInput" />
    <div v-if="!showSearchLoading && searchTag.length && !searchInput" class="mod-search__result mod-search__synthesize">
      <h3 class="mod-search__tit">为您推荐</h3>
      <ul class="mod-hot__list">
        <li
          v-for="(item, index) in searchTag"
          :key="'searchHistory' + index"
          class="mod-hot__item"
          role="button"
          @click.stop="searchSubmit(item.label_name, 'label')"
        >
          {{ item.label_name }}
        </li>
      </ul>
    </div>

    <!-- 搜索结果 -->
    <div v-if="searchInput" class="mod-search__result">
      <h3 class="mod-search__tit">相关道具</h3>
      <div v-if="showSearchLoading" class="mod-search__loading">
        <i class="weui-loading"></i>
      </div>
      <div v-if="!showSearchLoading && searchResult && searchResult.length" class="jf-smallShop__con">
        <div
          v-for="(daojuItem, index) in searchResult"
          :key="'daoju' + index"
          class="jf-smallShop__details"
          role="button"
          @click="goToDetail(daojuItem, index)"
        >
          <!-- 搜索查询结果换成新的一排一样式 -->
          <!-- <div class="mod-service">
            <div class="mod-service__hd"><img :src="daojuItem.icon || ''" alt="" class="mod-service__pic" /></div>
            <div class="mod-service__bd">
              <h4 class="mod-service__name padding-left">{{ daojuItem.name }}</h4>
              <p class="mod-service__desc">{{ daojuItem.goodsRemark }}</p>
            </div>
          </div> -->
          <div class="jf-smallShop__detailsL jf-layout_flex">
            <div class="jf-smallShop__detailsGoods">
              <div style="position: absolute; top: 0.08rem; left: 0.05rem">
                <div class="jf-tag jf-tag-obscure">{{ daojuItem.tag }}</div>
              </div>
              <img :src="daojuItem.icon" alt="" />
            </div>
            <div class="jf-smallShop__detailsTxt jf-layout_flexColumn">
              <span class="jf-smallShop__detailsName">{{ daojuItem.name }}</span>
              <div class="jf-layout_flexCenter">
                <p class="jf-smallShop__detailsPrice orange jf-layout_flexCenter">
                  <i class="jf-price-coupon" :style="{
                    backgroundImage: gameCoinIcon ? 'url(' + gameCoinIcon + ')' : '',
                    display: daojuItem.showGameCoinPrice && salePriceDisplay(daojuItem) ? 'inline-block' : 'none'
                  }"></i
                  >{{ salePriceDisplay(daojuItem) }}
                  <!-- <i class="jf-price-coupon"></i>{{ daojuItem.salePrice }} -->
                </p>
                <div v-if="daojuItem.activityTag !== ''" class="jf-tag jf-tag-orange">{{ daojuItem.activityTag }}</div>
              </div>
              <!-- 底部标签列表展示时默认展示前三个 并且过滤掉重复的第一个重复的tag-->
              <div v-if="daojuItem.tags && daojuItem.tags.filter(item => !!item).length > 1" class="jf-tag-list">
                <div v-for="(goodtags, i) in daojuItem.tags.filter(item => !!item)" :key="i">
                  <div v-if="i > 0 && i < 4" class="jf-tag jf-tag-yellow">{{ goodtags }}</div>
                </div>
              </div>
              <div v-else>
                <p style="font-size: 10px" class="active-name-detail">{{ daojuItem.goodsRemark }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!showSearchLoading && (!searchResult || !searchResult.length)" class="">
        <img class="search-empty" src="../../../ui/assets/mobile/images/search-empty.png" alt="" />
        <p class="mod-search__txt mod-search__txt--center">没搜到相关道具哦，请检查关键字</p>
      </div>
    </div>
    <!-- 相关资讯 -->
    <div v-if="searchInput && showNewsSearch" class="mod-search__result list-top">
      <h3 class="mod-search__tit">相关资讯</h3>
      <div v-if="showNewsSearchLoading" class="mod-search__loading">
        <i class="weui-loading"></i>
      </div>
      <div v-if="!showNewsSearchLoading && newsSearchResult && newsSearchResult.length" class="list-top-item list-top-article">
        <!-- <div class="link-more">
          <button class="small-btn small-btn--active">活动</button>
          <p class="link-title"><span class="mod-service__name-focus">夏日</span>感恩周，永久英雄等你开</p>
        </div> -->
        <template v-for="(newsItem, index) in newsSearchResult">
          <singleNewsLine
            :key="'news' + index"
            :news="newsItem"
            :offer-id="(currentItem.ams && currentItem.ams.offerid) || 1450002258"
            scene-id="42_dnf"
            pf-structure="search"
            :iformat="CLICK.SERVICEZONE_SEARCH_NEWS_RESULT"
            :click-action="goToNews"
            :index="index"
          ></singleNewsLine>
        </template>
        <!-- <div class="link-more"><button class="small-btn small-btn--article">视频</button><p class="link-title link-title--video">路易威登和全球总决赛展开合作关系</p></div> -->
      </div>
      <div v-if="!showNewsSearchLoading && (!newsSearchResult || !newsSearchResult.length)" class="">
        <img class="search-empty" src="../../../ui/assets/mobile/images/search-empty.png" alt="" />
        <p class="mod-search__txt mod-search__txt--center">没搜到相关资讯哦</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import localstorage from "@utils/localStorage"
import * as reportDict from "@constants/report-dictonary"
import * as langs from "@constants/langs"
import * as gamePorpsApi from "@api/gameProps.js"
import gameServiceZoneMixin from "../mixins/gameServiceZone"
import singleNewsLine from "./basic/singleNewsLine.vue"
import Raven from "raven-js"
import { handleTagRecommendResult } from "@api/recommend"
import "../../../ui/assets/mobile/css/small-shop.css"

export default {
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
      componentUpdated: function (el, binding) {
        if (binding.value) {
          el.focus()
        }
      }
    }
  },
  components: { singleNewsLine },
  mixins: [gameServiceZoneMixin],
  props: {
    isGameShop: {
      type: Boolean,
      default: false
    },
    filterList: {
      type: Array,
      default: () => []
    },
    goToGoodsDetail: {
      type: Function
    },
    searchShelfConfig: {
      type: [Object, undefined],
      default: undefined
    }
  },
  data() {
    return {
      searchInput: "",
      searchResult: [],
      newsSearchResult: [],
      inputFocus: true,
      showSearchLoading: false,
      showNewsSearchLoading: false,
      currentSearchTimer: null,
      // 搜索历史和搜索标签需要按业务区分
      searchHistory: [],
      store_service_zone_search_history: localstorage.get("store_service_zone_search_history", true) || {},
      searchTag: [],
      store_service_zone_tag: {},
      showInput: false,
      CLICK: reportDict.CLICK
    }
  },
  computed: {
    ...mapGetters(["currentItem", "userAgent", "searchTab", "serviceZoneSearchStatus"]),
    historyKey() {
      return this.currentItem ? `${this.currentItem.groupId}_${this.currentItem.busId}` : ""
    },
    searchTabConfig() {
      return this.searchShelfConfig || this.searchTab
    },
    newsSearchConfig() {
      return this.searchTabConfig?.searchConfig?.newsSearch || {}
    },
    daojuSearchConfig() {
      return this.searchTabConfig?.searchConfig?.daojuSearch || {}
    },
    tagSearchConfig() {
      return this.searchTabConfig?.searchConfig?.tagSearch || {}
    },
    // 当前搜索词是否在推荐标签里
    searchInputMatchTag() {
      return (
        (this.searchInput &&
          this.searchTag?.filter(tag => {
            return tag?.label_name == this.searchInput
          })[0]) ||
        null
      )
    },
    showNewsSearch() {
      // 如果配置展示0个 || 不配置模型id || 外部带货列表页 不展示 || 如果是标签搜索
      return this.newsSearchConfig?.limitNum === "0" || !this.newsSearchConfig?.activityId || this.isGameShop || this.searchInputMatchTag
        ? false
        : true
    },
    gameCoinIcon() {
      // 使用currentItem.gameCoinIcon背景图无法生效，故写在computed里
      return this.currentItem && this.currentItem.gameCoinIcon ? this.currentItem.gameCoinIcon : ""
    },
  },
  watch: {
    $route: function (to) {
      // 本路由下路由变化
      if (to.path.indexOf("order") > -1) {
        if (to.query && ~~to.query.searchBox) {
          this.changeServiceZoneSearchStatus(true)
          this.initSearchPage()
        } else {
          this.changeServiceZoneSearchStatus(false)
          this.showInput = false
          this.onBlur()
        }
      }
    },
    // 监听搜索输入框内容
    searchInput() {
      if (this.searchInput === "") {
        this.getSearchHistory()
      } else {
        this.getSearchResult()
      }
    },
    // 监听搜索框状态
    serviceZoneSearchStatus(newVal) {
      if (!newVal) {
        this.showInput = false
        this.clearSearchInput()
      }
    }
  },
  mounted() {
    let route = this.$route
    if (route.path.indexOf("order") > -1 && route.query && ~~route.query.searchBox) {
      // 页面刷新进入时，如果连接上有searchBox，需要先初始化为 0
      this.$router.replace({
        path: `/order/${this.$route.params.bizgroupid}/biz/${this.$route.params.bizid}`,
        query: {
          ...this.$route.query,
          searchBox: 0
        }
      })
    } else {
      this.changeServiceZoneSearchStatus(false)
    }
  },
  methods: {
    ...mapActions(["changeServiceZoneSearchStatus", "reportUserAction", "getRecommendByNode"]),
    salePriceDisplay (goods) {
      if (goods.saleChannelPrice) {
        return `${goods.saleChannelPrice}`
      } else if (goods.showGameCoinPrice) {
        return goods.salePrice
      } else {
        // 兼容价格为0，如果价格为0或空，则不显示￥
        return goods.saleCashRMBPrice ? `￥${goods.saleCashRMBPrice}` : ""
      }
    },
    closeSearchBox() {
      if (this.isGameShop) {
        this.changeServiceZoneSearchStatus(false)
      } else {
        this.$router.back()
      }
      // 优化，先跳转路由，再清空页面展示
      setTimeout(() => {
        this.searchInput = ""
        this.searchResult = []
        this.newsSearchResult = []
        this.showInput = false
      }, 0)

      this.reportUserAction({
        iformat: reportDict.CLICK.SERVICEZONE_SEARCH_CLOSE
      })
    },
    initSearchPage() {
      this.showInput = true
      this.getSearchHistory()

      // 上报页面曝光
      this.reportUserAction({
        iformat: reportDict.PAGE_VIEW.SERVICEZONE_SEARCH
      })
    },
    onFocus() {
      this.inputFocus = true
    },
    onBlur() {
      this.inputFocus = false

      //iOS12.1键盘弹起导致body上移,点击事件不触发的问题,通过让页面重绘解决
      if (this.userAgent.iOS) {
        // eslint-disable-next-line no-self-assign
        document.body && (document.body.scrollTop = document.body.scrollTop)
      }
    },
    clearSearchInput() {
      this.searchInput = ""
      this.searchResult = []
      this.newsSearchResult = []
    },
    // 搜索框确认、热门搜索和历史搜索点击
    searchSubmit(searchInput, from = "") {
      this.inputFocus = false

      if (searchInput) this.searchInput = searchInput
      this.setSearchHistory(this.searchInput)

      this.reportUserAction({
        iformat: `${reportDict.CLICK.SERVICEZONE_SUBMIR_SEARCH_CONTENT}_${from}`,
        resultInfo: {
          keyword: this.searchInput
        }
      })
    },

    /**
     * 1. 设置请求 cgi 延迟，0.5s 后再去请求
     * 2. 接搜索推荐
     */
    getSearchResult() {
      if (!this.searchInput) {
        return
      }

      this.showSearchLoading = true
      this.showNewsSearchLoading = true
      this.currentSearchTimer && clearTimeout(this.currentSearchTimer)

      this.currentSearchTimer = setTimeout(() => {
        const searchServicesPromises = []
        // 如果搜索内容在标签内
        if (this.searchInputMatchTag) {
          // 根据标签查询道具
          searchServicesPromises.push(
            this.getDaojuTagSearchServices({ labelId: this.searchInputMatchTag?.label_id, labelName: this.searchInputMatchTag?.label_name })
          )
          this.newsSearchResult = []
          this.showNewsSearchLoading = false
        } else {
          searchServicesPromises.push(this.getDaojuSearchServices(this.searchInput))

          if (!this.showNewsSearch) {
            this.newsSearchResult = []
            this.showNewsSearchLoading = false
          } else {
            searchServicesPromises.push(this.getNewsSearchServices(this.searchInput))
          }
        }

        Promise.allSettled(searchServicesPromises).then(res => {
          const [daojuSearchRes, newsSearchRes] = res
          if (daojuSearchRes.status !== "rejected") {
            // 这里要比较搜索结果的关键字和当前输入框是否一致，如果输入框内容已变，则不展示搜索结果
            if (this.searchInput === daojuSearchRes?.value?.searchInput) {
              let searchResult = daojuSearchRes?.value?.recommendList || []
              // 因为王者体验卡也会出现在搜索结果，而体验卡功能下线，统一不展示体验卡
              this.searchResultFilter({ resultList: searchResult, filterExperienceCard: true })
              this.showSearchLoading = false
            }
          } else {
            this.searchResult = []
            this.showSearchLoading = false
            Raven.captureException(new Error("zq-daoju-search-keyword-error"), {
              tag: { type: "zq-daoju-search-keyword-error" },
              extra: {
                data: daojuSearchRes.value,
                keyword: this.searchInput
              }
            })
          }
          if (newsSearchRes) {
            if (newsSearchRes.status !== "rejected") {
              // 这里要比较搜索结果的关键字和当前输入框是否一致，如果输入框内容已变，则不展示搜索结果
              if (this.searchInput === newsSearchRes?.value?.searchInput) {
                if (this.newsSearchConfig?.limitNum) {
                  this.newsSearchResult = newsSearchRes.value.recommendList.slice(0, ~~this.newsSearchConfig.limitNum)
                } else {
                  this.newsSearchResult = newsSearchRes.value.recommendList
                }
                this.showNewsSearchLoading = false
              }
            } else {
              this.newsSearchResult = []
              this.showNewsSearchLoading = false
              Raven.captureException(new Error("zq-news-search-keyword-error"), {
                tag: { type: "zq-news-search-keyword-error" },
                extra: {
                  data: newsSearchRes.value,
                  keyword: this.searchInput
                }
              })
            }
          }

          const resultInfo = {
            keyword: this.searchInput,
            prouductId: Array.isArray(this.searchResult)
              ? this.searchResult.map(searchItem => searchItem?.itemExtend?.AMSID || searchItem?.goodsId || "").join(",")
              : [],
            contentId: Array.isArray(this.newsSearchResult)
              ? this.newsSearchResult.map(newsSearchItem => newsSearchItem.contentId).join(",")
              : []
          }
          this.reportUserAction({
            iformat: `${reportDict.CLICK.SERVICEZONE_SEARCH_RESULT}`,
            resultInfo: resultInfo
          })
        })
      }, 500)
    },
    // 过滤体验卡 & 限制搜索结果长度
    searchResultFilter({ resultList, filterExperienceCard }) {
      let searchResult = resultList
      if (filterExperienceCard) {
        // 过滤全部体验卡
        searchResult = resultList.filter(goodsItem => {
          return !gamePorpsApi.isExperienceCard(goodsItem)
        })
      } else {
        // 过滤过期的体验卡
        searchResult = resultList.filter(goodsItem => {
          return !(gamePorpsApi.isExperienceCard(goodsItem) && !gamePorpsApi.checkCardActivityValid(goodsItem))
        })
      }
      if (this.daojuSearchConfig?.limitNum) {
        this.searchResult = searchResult.slice(0, ~~this.daojuSearchConfig.limitNum)
      } else {
        this.searchResult = searchResult
      }
      this.isGameShop && this.searchResultFilters(this.searchResult)
    },
    getDaojuSearchServices(keyword) {
      //node 推荐
      return this.getRecommendByNode({ keyword, recommConfig: this.daojuSearchConfig, service: "daoju_search" })
        .then(recommendList => {
          return {
            searchInput: keyword,
            recommendList
          }
        })
        .catch(() => {
          return {
            searchInput: keyword,
            recommendList: []
          }
        })
    },
    getNewsSearchServices(keyword) {
      // 需要把搜索模型配置传递过去
      return this.getRecommendByNode({ keyword, recommConfig: this.newsSearchConfig })
        .then(recommendList => {
          return {
            searchInput: keyword,
            recommendList
          }
        })
        .catch(() => {
          return {
            searchInput: keyword,
            recommendList: []
          }
        })
    },
    getDaojuTagSearchServices({ labelId, labelName }) {
      //node 推荐
      return this.getRecommendByNode({
        keyName: labelId,
        recommConfig: {
          activityId: this.tagSearchConfig?.activityId?.split(";")[1]
        },
        service: "itemlabel"
      })
        .then(recommendList => {
          return {
            searchInput: labelName,
            recommendList
          }
        })
        .catch(() => {
          return {
            searchInput: labelName,
            recommendList: []
          }
        })
    },
    // 历史搜索
    setSearchHistory(searchInput) {
      if (!searchInput) return

      if (this.searchHistory.indexOf(searchInput) === -1) {
        if (this.searchHistory.length >= langs.SERVICEZONE_MAX_SEARCH_HISTORY_CAPACITY) {
          this.searchHistory.pop()
        }
        this.searchHistory.unshift(searchInput)
      } else {
        let num = this.searchHistory.indexOf(searchInput)
        this.searchHistory.splice(num, 1)
        this.searchHistory.unshift(searchInput)
      }
      this.store_service_zone_search_history[this.historyKey] = this.searchHistory
      localstorage.set("store_service_zone_search_history", JSON.stringify(this.store_service_zone_search_history))
    },
    // 历史搜索
    getSearchHistory() {
      // 重置历史搜索（专区间切换）
      if (this.historyKey) {
        this.searchHistory = this.store_service_zone_search_history[this.historyKey] || []
      }

      this.getRecommTagList()
    },
    // 获取业务的标签推荐
    getRecommTagList() {
      // 如果已有该业务标签，则无需请求
      if (this.store_service_zone_tag && this.historyKey && this.store_service_zone_tag[this.historyKey]) {
        this.searchTag = this.store_service_zone_tag[this.historyKey]
        return
      }

      // 重置标签列表
      this.searchTag = []
      // 如果没有配置业务标签推荐模型，则无需请求
      if (this.tagSearchConfig?.activityId?.split(";")[0]) {
        // 查标签推荐
        this.getRecommendByNode({
          keyName: this.currentItem?.ams?.offerid,
          recommConfig: { activityId: this.tagSearchConfig?.activityId?.split(";")[0] },
          service: "labelrcmd"
        }).then(res => {
          this.searchTag = handleTagRecommendResult(res)
          this.store_service_zone_tag[this.historyKey] = this.searchTag
        })
      }
    },
    // 清空历史搜索记录
    clearSearchHistory() {
      if (this.historyKey) {
        this.store_service_zone_search_history[this.historyKey] = []
        localstorage.set("store_service_zone_search_history", JSON.stringify(this.store_service_zone_search_history))
        this.searchHistory = []

        this.reportUserAction({
          iformat: reportDict.CLICK.SERVICEZONE_CLEAR_HISTORY_SEARCH
        })
      }
    },

    goToDetail(goodsItem, index) {
      if (this.isGameShop) {
        this.goToGoodsDetail({ goods: goodsItem })
        return
      }
      // 用户点击搜索结果则记录当前搜索关键字到历史搜索中
      this.setSearchHistory(this.searchInput)

      this.goToPropDetail({
        prop: goodsItem,
        pfStructure: "search",
        reportIformat: reportDict.CLICK.SERVICEZONE_SEARCH_DAOJU_RESULT,
        resultInfo: {
          index
        }
      })
    },
    goToNews() {
      // 用户点击搜索结果则记录当前搜索关键字到历史搜索中
      this.setSearchHistory(this.searchInput)
    },
    // 从快手主播店铺推荐商品中筛选
    searchResultFilters(resultList) {
      let resultListArr = resultList.map(item => item.itemId)
      let searchResult = this.filterList.filter(item => {
        return resultListArr.indexOf(item.itemId) > -1
      })
      this.searchResult = searchResult
    }
  }
}
</script>

<style scoped>
.mod-search__txt.mod-search__txt--center {
  border-bottom: none;
}
</style>
